"use strict";
import f from "./index.es350.js";
import m from "./index.es351.js";
function l(t, e, r) {
  let a = !f(e);
  return t && (a || r == !1) ? m(t, e) : e;
}
export {
  l as default
};
//# sourceMappingURL=index.es263.js.map
